import { Button, EButtonColor } from '@web_opxp/components';
import * as React from 'react';
import { IRadioButtonItem } from '../../types';
import './RadioButton.scss';

export interface IRadioButtonProps {
  items: IRadioButtonItem[];
  activeItem: string;
  onClick: (item: string) => void;
}

const RadioButton = ({ items, activeItem, onClick }: IRadioButtonProps) => {
  return (
    <div className="radio-button">
      {items.map(({ key, title }) => (
        <Button
          color={activeItem === key ? EButtonColor.blue : EButtonColor.white}
          key={key}
          className="radio-button-item"
          onClick={() => onClick(key)}
          label={title}></Button>
      ))}
    </div>
  );
};

export default RadioButton;
